/**
 * register-validations.js
 * B2B Registration Form — client-side validation
 *
 * Behaviour:
 *  - No errors shown until first submit attempt
 *  - After first attempt: live validation fires on every input / blur / change
 *  - Empty required field  → "X is required"
 *  - Non-empty but invalid → format/pattern error message
 *  - Red border + tinted bg + red message below field on error
 *  - Green border + tinted bg once resolved
 *  - Auto-scroll + focus to first error on failed submit
 *  - Password show/hide toggle
 */

(function () {
  'use strict';

  var RULES = {
    'b2b-bizname': {
      required: true,
      requiredMessage: 'Business name is required',
      regex: /\S+/,
      message: 'Business name is required'
    },
    'b2b-addr1': {
      required: true,
      requiredMessage: 'Address line 1 is required',
      regex: /\S+/,
      message: 'Address line 1 is required'
    },
    'b2b-country': {
      required: true,
      requiredMessage: 'Please select a country',
      regex: /\S+/,
      message: 'Please select a country'
    },
    'b2b-abn': {
      required: true,
      requiredMessage: 'ABN/ACN is required',
      regex: /^\d{9,11}$/,
      message: 'Please enter a valid ABN/ACN (9\u201311 digits)'
    },
    'b2b-phone': {
      required: true,
      requiredMessage: 'Phone number is required',
      regex: /^\d{7,15}$/,
      message: 'Phone must contain 7\u201315 digits only'
    },
    'b2b-website': {
      required: true,
      requiredMessage: 'Website is required',
      regex: /^(https?:\/\/)[\w\-]+(\.[\w\-]+)+/i,
      message: 'Enter a valid URL (e.g. https://example.com)'
    },
    'b2b-name': {
      required: true,
      requiredMessage: 'Contact name is required',
      regex: /^[A-Za-z\s]+$/,
      message: 'Name should only contain letters and spaces'
    },
    'b2b-email': {
      required: true,
      requiredMessage: 'Email address is required',
      regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: 'Enter a valid email address'
    },
    'b2b-password': {
      required: true,
      requiredMessage: 'Password is required',
      regex: /^.{8,}$/,
      message: 'Password must be at least 8 characters'
    }
  };

  var formSubmitted = false;

  function validateField(id) {
    var rule = RULES[id];
    if (!rule) return true;

    var el = document.getElementById(id);
    var errEl = document.getElementById(id + '-err');
    if (!el) return true;

    var value = el.value.trim();
    var isValid = true;
    var errorMessage = '';

    if (rule.required && value === '') {
      isValid = false;
      errorMessage = rule.requiredMessage || rule.message;
    } else if (value !== '' && rule.regex && !rule.regex.test(value)) {
      isValid = false;
      errorMessage = rule.message;
    }

    if (!isValid && formSubmitted) {
      if (errEl) {
        errEl.querySelector('.b2b-err-text').textContent = errorMessage;
        errEl.classList.add('b2b-show');
      }
    } else {
      if (errEl) errEl.classList.remove('b2b-show');
    }

    return isValid;
  }

  function validateAll() {
    var allValid = true;
    Object.keys(RULES).forEach(function (id) {
      if (!validateField(id)) allValid = false;
    });
    return allValid;
  }

  function init() {
    var submitBtn = document.getElementById('b2b-submit');
    if (!submitBtn) return;

    Object.keys(RULES).forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      ['input', 'blur', 'change'].forEach(function (evt) {
        el.addEventListener(evt, function () {
          if (formSubmitted) validateField(id);
        });
      });
    });

    submitBtn.addEventListener('click', function (e) {
      formSubmitted = true;
      var isValid = validateAll();
      if (!isValid) {
        e.preventDefault();
        var firstError = document.querySelector('.b2b-field-error.b2b-show');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });

    var eyeBtn  = document.getElementById('b2b-eye-btn');
    var pwInput = document.getElementById('b2b-password');
    var eyeIcon = document.getElementById('b2b-eye-icon');

    if (eyeBtn && pwInput && eyeIcon) {
      eyeBtn.addEventListener('click', function () {
        var hidden = pwInput.type === 'password';
        pwInput.type = hidden ? 'text' : 'password';
        eyeIcon.innerHTML = hidden
          ? '<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/>'
          : '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
